import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loaderContainer">
      <div className="ott-loader">
        <img
          src={`/${process.env.REACT_APP_APP_LOGO}`}
          alt={process.env.REACT_APP_SITE_TITLE}
          className="ott-loader__logo"
        />
        <div className="ott-loader__ring" />
      </div>
    </div>
  );
};

export default Loader;
